import Navbar from "../navbar/Navbar";

function Header() {
  return (
    <div className="bg-white flex-none md:drop-shadow">
      <Navbar />
    </div>
  );
}

export default Header;
